import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'

const GlobalStyles = createGlobalStyle`
${reset}

@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR&display=swap');

* {
  box-sizing: border-box;
  font-family: 'Noto Sans', sans-serif !important;
}
button {
  border: none;
  cursor: pointer;
  background-color: transparent;
}
input {
  border: none;
  background-color: inherit;
}
input:focus {
  outline: none;
}
a {
  text-decoration: none;
  color: inherit;
}
.ir {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.custom-dialog {
  width: 320px;
  margin: 0 auto;
}

.modal { 
  padding-right: 0px !important; 
  display: flex ;
  justify-content: center;
  }
  .modal-backdrop.show{
    width: 100%;
    height: 100%;
  }
/* sidebar */
@media (max-width: 1024px) {
  .offcanvas.offcanvas-start {
    width: 241px;
  }

  .offcanvas-body {
    position: relative;
      &::-webkit-scrollbar {
        display: none;
      }
  }
}

@media (max-width: 480px) {
  .offcanvas.offcanvas-start {
    width: 361px;
  }

  .offcanvas-body {
      &::-webkit-scrollbar {
        display: none;
      }
  }
}

/* 휴무일 푸터 관련 */
.rdp-months {
  div:nth-child(2) {
    tfoot {
      display: none;
    }
  }
}
`

export default GlobalStyles
